export const LOAD_INVOICES = 'LOAD_INVOICES'
export const LOAD_ALL_INVOICES = 'LOAD_ALL_INVOICES'
export const LOAD_INVOICE_STATUS = 'LOAD_INVOICE_STATUS'
export const LOAD_INVOICE_PAID_STATUS = 'LOAD_INVOICE_PAID_STATUS'